import produce from 'immer';
import Queue from 'helpers/queue';

const queueRequest = new Queue();

// Delete thread
export const deleteThreadSuccess = (actions, state) => {
  return produce(state, (draft) => {
    const listInboxAfterFilter =
      draft.listInBox &&
      draft.listInBox.filter((el) => !actions.listInboxChecked.includes(el.thread));
    draft.isDeleting = false;
    draft.listInBox = listInboxAfterFilter;
  });
};

// Change star
export const baseStar = () => ({
  isChangeStar: false,
  queueStar: queueRequest.queue,
});

export const fetchChangeStar = (actions, state) => {
  queueRequest.pushToQueue(actions.id);
  return produce(state, (draft) => {
    draft.isChangeStar = true;
    draft.queueStar = queueRequest.queue;
  });
};

export const fetchChangeStarSuccess = (actions, state) => {
  queueRequest.removeFromQueue(actions.id);
  return produce(state, (draft) => {
    const { inboxDetail } = draft;
    const index = inboxDetail.findIndex((el) => el.id === actions.idStar);
    inboxDetail[index]['star'] = actions.value;

    draft.inboxDetail = inboxDetail;
    draft.isChangeStar = false;
    draft.queueStar = queueRequest.queue;
  });
};

export const fetchChangeStarFailed = (actions, state) => {
  queueRequest.removeFromQueue(actions.id);
  return produce(state, (draft) => {
    draft.isChangeStar = false;
    draft.queueStar = queueRequest.queue;
  });
};

// inbox
export const baseSendInbox = () => ({
  isSendingServlet: false,
});

export const fetchSendInbox = (actions, state) => {
  return produce(state, (draft) => {
    draft.isSendingServlet = true;
  });
};

export const fetchSendInboxSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isSendingServlet = false;
  });
};

export const fetchSendInboxFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isSendingServlet = false;
    draft.errorSendInbox = actions.errorSendInbox;
  });
};

export const updateNewInbox = (actions, state) => {
  const { payload } = actions;
  const { thread, phoneSelected, message } = payload;

  const template = {
    isOut: 1,
    extraInfo: '',
    fromPhone: phoneSelected,
    read: true,
    id: new Date().getTime(),
    message,
    sentDate: '',
    sentTime: '',
    star: 0,
    delivered: true,
    threadShown: '',
    thread,
    toPhone: thread,
    out: true,
  };

  return produce(state, (draft) => {
    if (draft.inboxDetail) {
      // resolve case 3 TA-637
      draft.inboxDetail.unshift(template);
    }
  });
};

// update inbox detail
export const baseInboxDetail = () => ({
  isFetchingDetail: false,
  inboxDetail: null,
});

export const fetchGetInboxDetail = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingDetail = true;
  });
};

export const fetchGetInboxDetailSuccess = (actions, state) => {
  return produce(state, (draft) => {
    const { listInBox } = draft;
    const { idDetail } = actions;
    const index = listInBox.findIndex((el) => el.id === idDetail);
    if (~index && listInBox[index]['read'] === false) {
      listInBox[index]['read'] = true;
    }

    draft.listInBox = listInBox;
    draft.inboxDetail = actions.inboxDetail;
    draft.idInboxDetail = actions.idDetail;
    draft.isFetchingDetail = false;
  });
};

export const fetchGetInboxDetailFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingDetail = false;
  });
};

export const clearInboxDetail = (actions, state) => {
  return produce(state, (draft) => {
    draft.inboxDetail = null;
    draft.idInboxDetail = null;
  });
};
